__turbopack_context__.v({
  "plContentShell": "ZG_ixa_plContentShell",
  "plContentShellCentered": "ZG_ixa_plContentShellCentered",
  "plDividerHorizontal": "ZG_ixa_plDividerHorizontal",
  "plDividerVertical": "ZG_ixa_plDividerVertical",
  "plPillarBody": "ZG_ixa_plPillarBody",
  "plPillarEmphasis": "ZG_ixa_plPillarEmphasis",
  "plPillarTitle": "ZG_ixa_plPillarTitle",
  "plSectionHeader": "ZG_ixa_plSectionHeader",
  "plSectionHeading": "ZG_ixa_plSectionHeading",
  "plSectionLabel": "ZG_ixa_plSectionLabel",
  "plSectionRoot": "ZG_ixa_plSectionRoot",
  "plTitleStack": "ZG_ixa_plTitleStack",
});
